/// <reference path="../_references.ts"/>

module App.Administrative.PurchaseOrder {
	export type PurchaseOrderType = {
		id: number;
		name: string;
	}

	export class PO {
		id: number = null;
		note: string = null;
		supplier: string = null;
		amount: number = null;
		service_request: number = null;
		address: number = null;
		purchase_order_type: string = null;

		constructor(data?: PO) {
			data = data || this;

			this.id = data.id;
			this.note = data.note;
			this.supplier = data.supplier;
			this.amount = data.amount;
			this.service_request = data.service_request;
			this.address = data.address;
			this.purchase_order_type = data.purchase_order_type;
		}
	}
}